import { Message as MessageT } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { ConversationAuditLogEntry } from 'apis/auditLogs';
import { getMessageSanitizationChannel } from 'app/utils/htmlSanitizer';

import { Message } from '../../../conversation/components/message';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import styles from './logEntry/logEntry.module.scss';
import { UserLink } from './userLink/userLink';

type MessageAddedProps = {
  entry: ConversationAuditLogEntry<
    'MESSAGE_ADDED_BY_AGENT' | 'MESSAGE_ADDED_BY_CUSTOMER'
  >;
  messages: Array<MessageT>;
};

export const MessageAdded = ({
  entry,
  messages,
}: MessageAddedProps): JSX.Element => {
  const authorName = getLogEntryAuthorName(entry);
  const authorLink = <UserLink userId={entry.author.id}>{authorName}</UserLink>;

  const userType =
    entry.activity_type === 'MESSAGE_ADDED_BY_AGENT' ? 'agent' : 'customer';

  const text = (
    <>
      Message is added by {userType} {authorLink}
    </>
  );
  const author: User = {
    id: entry.author.id,
    name: entry.author.name ?? null,
    email: entry.author.email ?? null,
    phone_number: entry.author.phone_number ?? null,
    avatar_url: entry.avatar_url ?? null,
    type: userType === 'agent' ? 'member' : 'contact',
    org_id: null,
    company_id: null,
    default_outbound_number: null,
    anonymized_at: null,
    given_name: null,
    family_name: null,
    has_scim_enabled: false,
    external_id: null,
  };

  const message = messages.find((message) => message.id === entry.message_id);

  return (
    <LogEntry entry={entry} text={text}>
      {message?.text ? (
        <Message
          className={styles.message}
          author={author}
          markup={message.text}
          date=""
          channel={getMessageSanitizationChannel(message)}
        />
      ) : null}
    </LogEntry>
  );
};
